(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nataura-horizontal-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nataura-horizontal-reviews')) {
    customElements.define('nataura-horizontal-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.controls = this.querySelector('[data-review-controls]');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        if (!this.track) return;
        this.update = () => {
          const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.controls.hidden = maximum < 2;
          this.previous.disabled = this.track.scrollLeft < 2;
          this.next.disabled = this.track.scrollLeft >= maximum - 2;
        };
        this.move = direction => {
          const card = this.track.querySelector('.nr__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth'});
        };
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onSelect = event => {
          const card = event.target.closest('.nr__card');
          if (card) this.track.scrollTo({left: card.offsetLeft, behavior: 'auto'});
        };
        this.previous.addEventListener('click', this.onPrevious);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.update, {passive: true});
        this.addEventListener('shopify:block:select', this.onSelect);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.update);
        this.removeEventListener('shopify:block:select', this.onSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profile-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nataura-profile-marquee')) {
    customElements.define('nataura-profile-marquee', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.npm__viewport');
        this.track = this.querySelector('.npm__track');
        this.group = this.querySelector('[data-source-group]');
        this.control = this.querySelector('[data-pause]');
        if (!this.group || !this.group.children.length) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onPause = () => {
          const paused = this.toggleAttribute('data-paused');
          this.control.setAttribute('aria-pressed', String(paused));
          this.control.setAttribute('aria-label', paused ? 'Resume scrolling' : 'Pause scrolling');
        };
        this.scheduleBuild = () => {
          cancelAnimationFrame(this.buildFrame);
          this.buildFrame = requestAnimationFrame(() => this.build());
        };
        this.onSelect = () => this.setAttribute('data-editor-selected', '');
        this.onDeselect = () => this.removeAttribute('data-editor-selected');
        this.control.addEventListener('click', this.onPause);
        this.motionQuery.addEventListener('change', this.scheduleBuild);
        this.addEventListener('shopify:block:select', this.onSelect);
        this.addEventListener('shopify:block:deselect', this.onDeselect);
        this.observer = new ResizeObserver(this.scheduleBuild);
        this.observer.observe(this.viewport);
        this.build();
      }

      cleanCopy(element) {
        const copy = element.cloneNode(true);
        const nodes = [copy, ...copy.querySelectorAll('*')];
        const ids = new Map();
        this.copyIndex = (this.copyIndex || 0) + 1;
        for (const node of nodes) {
          for (const attribute of Array.from(node.attributes)) {
            if (attribute.name.startsWith('data-shopify')) {
              node.removeAttribute(attribute.name);
            }
          }
          if (node.id) {
            const replacement = `${this.id}-copy-${this.copyIndex}-${ids.size}`;
            ids.set(node.id, replacement);
            node.id = replacement;
          }
        }
        // Preserve SVG gradients, masks, clip paths, and symbol references in repeated cards.
        const rewriteUrls = value => value.replace(/url\(\s*(['"]?)#([^\s'"\)]+)\1\s*\)/g, (match, quote, id) => ids.has(id) ? `url(#${ids.get(id)})` : match);
        for (const node of nodes) {
          for (const attribute of Array.from(node.attributes)) {
            let value = rewriteUrls(attribute.value);
            if ((attribute.name === 'href' || attribute.name === 'xlink:href') && value.startsWith('#')) {
              value = ids.has(value.slice(1)) ? `#${ids.get(value.slice(1))}` : value;
            }
            if (attribute.name === 'aria-labelledby' || attribute.name === 'aria-describedby') {
              value = value.split(/\s+/).map(id => ids.get(id) || id).join(' ');
            }
            if (value !== attribute.value) node.setAttribute(attribute.name, value);
          }
          if (node.localName === 'style') {
            node.textContent = rewriteUrls(node.textContent).replace(/#([a-zA-Z_][\w-]*)/g, (match, id) => ids.has(id) ? `#${ids.get(id)}` : match);
          }
        }
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        return copy;
      }

      build() {
        if (!this.isConnected) return;
        this.removeAttribute('data-ready');
        this.control.hidden = true;
        this.track.querySelectorAll('[data-generated-group]').forEach(node => node.remove());
        this.group.querySelectorAll('[data-repeat]').forEach(node => node.remove());
        this.viewport.scrollLeft = 0;
        if (this.motionQuery.matches) return;

        const originalCards = Array.from(this.group.children);
        const baseWidth = this.group.getBoundingClientRect().width;
        const viewportWidth = this.viewport.clientWidth;
        if (!baseWidth || !viewportWidth) return;

        const repetitions = Math.max(1, Math.ceil((viewportWidth + 1) / baseWidth));
        for (let repetition = 1; repetition < repetitions; repetition += 1) {
          for (const card of originalCards) {
            const copy = this.cleanCopy(card);
            copy.setAttribute('data-repeat', '');
            this.group.append(copy);
          }
        }

        const distance = this.group.getBoundingClientRect().width;
        const duplicate = this.cleanCopy(this.group);
        duplicate.removeAttribute('data-source-group');
        duplicate.setAttribute('data-generated-group', '');
        this.track.append(duplicate);
        const speed = Math.max(1, Number(this.dataset.speed) || 40);
        this.style.setProperty('--npm-distance', `${distance}px`);
        this.style.setProperty('--npm-duration', `${distance / speed}s`);
        this.setAttribute('data-ready', '');
        this.control.hidden = false;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.buildFrame);
        this.observer?.disconnect();
        this.control?.removeEventListener('click', this.onPause);
        this.motionQuery?.removeEventListener('change', this.scheduleBuild);
        this.removeEventListener('shopify:block:select', this.onSelect);
        this.removeEventListener('shopify:block:deselect', this.onDeselect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
